function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 83 85"
}, props), React.createElement("path", {
  d: "M10.692 81.053c0-3.084-.058-7.544.248-10.984.223-2.552 3.171-3.517 4.623-1.518 1 1.378 2.019 2.643 3.038 3.804 10.526 12.047 27.177 15.172 40.397 6.936 17.626-10.984 21.408-35.316 21.408-35.316 3.515-19.43-4.77-29.813-9.73-33.232-2.439-1.678-5.31-2.53-8.189-2.377-5.266.294-7.482 3.853-8.393 7.272-.687 2.586-3.91 2.901-4.973.468-1.719-3.95-2.725-8.649-2.725-13.823v-1.23",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M16.445 40.872v10.39c0 1.769.917 3.377 2.356 4.18 2.834 1.588 5.547 2.727 7.91 3.392 9.87 2.79 18.217-3.685 19.16-13.858.707-7.593-2.872-14.382-2.872-14.382-6.19-12.697-6.4-24.96-6.4-24.96V1.06M1.172 81.054V67.811c0-6.257 3.509-10.068 5.756-11.872 1.147-.915 1.847-2.363 1.847-3.922V40.865",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M74.714 47.347a64.864 64.864 0 01-1.481 4.7c.038-20.762-6.311-31.443-14.127-36.181.315-.716.693-1.214 1.132-1.563.575-.456 1.357-.738 2.493-.8l.015-.001.014-.001c.117-.01.235-.01.407-.01 1.689 0 3.435.553 4.933 1.584.51.352 3.295 2.411 5.512 6.817 2.205 4.382 3.885 11.157 2.115 21.02l-.048.14v.133l-.043.238c-.037.199-.094.487-.172.855-.156.736-.4 1.787-.75 3.07z",
  fill: "#fff",
  stroke: "#5FB9D7",
  strokeWidth: "2"
})));